import { render } from "./BannerInicio.vue?vue&type=template&id=e0b93b36&scoped=true"
import script from "./BannerInicio.vue?vue&type=script&lang=js"
export * from "./BannerInicio.vue?vue&type=script&lang=js"

import "./BannerInicio.vue?vue&type=style&index=0&id=e0b93b36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b93b36"]])

export default __exports__